import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';

import {
  internalInformationFormatter,
  orderCustomerInformationFormatter,
  orderDateFormatter,
  orderLinkFormatter,
  orderTotalCurrencyFormatter,
  packageInformationFormatter,
} from '../formatters';

export const columns: Array<GridColDef> = [
  {
    field: 'order_customer_information',
    headerName: 'Order / Customer',
    sortable: false,
    flex: 3,
    minWidth: 250,
    renderCell: (params: GridRenderCellParams) => orderCustomerInformationFormatter(params, params.row.customerId),
    display: 'flex',
  },
  {
    field: 'checkin_departure',
    headerName: 'Check In / Departure',
    sortable: false,
    flex: 2,
    renderCell: orderDateFormatter,
    display: 'flex',
  },
  {
    field: 'package_information',
    headerName: 'Package Information',
    sortable: false,
    flex: 2,
    renderCell: packageInformationFormatter,
    display: 'flex',
  },
  {
    field: 'internal_information',
    headerName: 'Internal Information',
    sortable: false,
    flex: 3,
    renderCell: internalInformationFormatter,
    display: 'flex',
  },
  {
    field: 'order_total_currency',
    headerName: 'Order Total',
    sortable: false,
    flex: 1,
    renderCell: orderTotalCurrencyFormatter,
    display: 'flex',
  },
  { field: 'actions', headerName: 'Details', sortable: false, renderCell: orderLinkFormatter, display: 'flex' },
];
